"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const mobx_react_1 = require("mobx-react");
const hui_1 = require("@mit/hui");
const Formatters_1 = require("../../common/Formatters");
const ContactTracingApi_1 = __importDefault(require("../../api/ContactTracingApi"));
const addContactButton_1 = __importDefault(require("./addContactButton"));
const react_toastify_1 = require("react-toastify");
const QuestionsViewComponent = ({ mitId, caseData, contact, roles, addedContactCallback }) => {
    //used for page loading state
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    //checking if authed 
    const [unAuth, setUnAuth] = (0, react_1.useState)(false);
    //load errors
    const [isError, setError] = (0, react_1.useState)(false);
    //store initial values and values from the backend for the questions
    const [contactQuestions, setContactQuestions] = (0, react_1.useState)(false);
    //store person types for the "report symptoms question"
    const [personTypes, setPersonTypes] = (0, react_1.useState)(false);
    //store exposure types
    const [exposureTypes, setExposureTypes] = (0, react_1.useState)(false);
    //store test stream types
    const [testStreamTypes, setTestStreamTypes] = (0, react_1.useState)(false);
    //store spaces
    const [buildings, setBuildings] = (0, react_1.useState)([]);
    //store locations 
    // const [locations, setLocations] = useState<any>([]);
    //is busy flag for form processing
    const [isBusyUpdating, setIsBusyUpdating] = (0, react_1.useState)(false);
    // show hide emergency contact person inputs flag
    const [addingContactPerson, setAddingContactPerson] = (0, react_1.useState)(false);
    // show hide last shot date inputs flag
    const [showLastShotDate, setShowLastShotDate] = (0, react_1.useState)(false);
    //store only data to be saved on update
    const [answers, setAnswers] = (0, react_1.useState)({});
    const methods = {
        getTextCount() {
        },
        //load all data
        fetchAllData() {
            setLoading(true);
            Promise
                .all([
                ContactTracingApi_1.default.fetchContactQuestionPersonTypes(),
                ContactTracingApi_1.default.fetchContactQuestionExposureTypes(),
                ContactTracingApi_1.default.fetchContactQuestionTestStreamTypes(),
                ContactTracingApi_1.default.fetchBuildings(),
                // contactTracingApi.fetchLocations(),
                ContactTracingApi_1.default.fetchContactQuestions(mitId, caseData.case_guid, contact === null || contact === void 0 ? void 0 : contact.contact_guid)
            ])
                .then(([personTypesRes, exposureTypesRes, testStreamTypesRes, buildingsRes, /*  locationsRes, */ questionsRes]) => {
                // console.log('PROMISES DONE', JSON.stringify({questionsRes, personTypesRes, exposureTypesRes}, null, 4));
                setError(false);
                if (personTypesRes.error) {
                    // setError(true);
                    react_toastify_1.toast.error('Could not fetch person types.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                else if (personTypesRes.unauth) {
                    setUnAuth(true);
                }
                else {
                    setPersonTypes(personTypesRes.items.map((o) => ({
                        id: o.type_id,
                        text: o.name,
                        icon: ''
                    })));
                }
                if (exposureTypesRes.error) {
                    // setError(true);
                    react_toastify_1.toast.error('Could not fetch exposure types.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                else if (exposureTypesRes.unauth) {
                    setUnAuth(true);
                }
                else {
                    setExposureTypes(exposureTypesRes.items.map((o) => ({
                        id: o.type_id,
                        text: o.name,
                        icon: ''
                    })));
                }
                if (testStreamTypesRes.error) {
                    // setError(true);
                    react_toastify_1.toast.error('Could not fetch test stream types.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                else if (testStreamTypesRes.unauth) {
                    setUnAuth(true);
                }
                else {
                    setTestStreamTypes(testStreamTypesRes.items.map((o) => ({
                        id: o.type_id,
                        text: o.name,
                        icon: ''
                    })));
                }
                if (buildingsRes.error) {
                    // setError(true);
                    react_toastify_1.toast.error('Could not fetch buildings types.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                else if (buildingsRes.unauth) {
                    setUnAuth(true);
                }
                else {
                    setBuildings(buildingsRes.items.map((o) => ({
                        id: o.id,
                        text: o.name_long,
                        secondaryText: o.name,
                        icon: ''
                    })));
                }
                /* if(locationsRes.error){
                    // setError(true);
                    toast.error('Could not fetch locations types.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    })
                }
                else if (locationsRes.unauth) { setUnAuth(true) }
                else {
                    setLocations(locationsRes.items.map((o:any)=> ({
                        id: o.id,
                        text: o.name,
                        icon: ''
                    })))
                } */
                if (questionsRes.error) {
                    setError(true);
                    react_toastify_1.toast.error('Could not fetch questions.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                else if (questionsRes.unauth) {
                    setUnAuth(true);
                }
                else {
                    let newQuestionsData = methods.initialiseData(
                    // personTypesRes.items,
                    exposureTypesRes.items, 
                    // testStreamTypesRes.items,
                    // buildingsRes.items, 
                    // locationsRes.items,
                    questionsRes.items);
                    setContactQuestions(newQuestionsData);
                }
                setLoading(false);
            });
        },
        //getMaxDate max date config for date input
        getMaxDate(date) {
            date = date instanceof Date ? date : new Date(date);
            return { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
        },
        //mapping initial dropdown input value [from DB as id] to dropdown config obj.
        getDropdownValueConfigs(id, dataSet) {
            if (!id)
                return id;
            return dataSet.find((o) => (o.id || o.type_id) === id);
        },
        getAutocompleteTagsValueConfigs(ids, dataSet) {
            let configs = [];
            if (ids) {
                configs = ids.map((id) => {
                    let match = dataSet.find((o) => (o.id || o.type_id) === id);
                    return {
                        id: match.id || match.type_id,
                        text: match.text || match.name,
                    };
                });
            }
            return configs;
        },
        //map and merge data for initial values and saving answers on load and after save
        initialiseData(/* personTypesRes:any, */ exposureTypesRes, /* testStreamTypesRes:any, */ /* buildingsRes:any, */ /*  locationsRes:any, */ questionData) {
            //map only answers with values for saving. "updateAnswers" will change values on change and remove if inputs are cleared or empty
            //Note empty lists are not removed, just null values because an empty list will override a list in the DB.
            let answerData = {};
            Object.keys(questionData).forEach((key) => {
                if (questionData[key] !== null) {
                    answerData[key] = questionData[key];
                }
            });
            setAnswers(answerData);
            //map spaces/building ids to input config for autocomplete type tags
            /* if(questionData.fac_building_keys.length > 0){
                questionData.fac_building_keys = methods.getAutocompleteTagsValueConfigs(questionData.fac_building_keys, buildingsRes);
            } */
            //map locations/medical location ids to input config for autocomplete type tags
            /* if(questionData.medical_location_ids.length > 0){
                questionData.medical_location_ids = methods.getAutocompleteTagsValueConfigs(questionData.medical_location_ids, locationsRes);
            } */
            //map exposure type ids to input config
            if (questionData.ct_question_medical_exposures_type_ids.length > 0) {
                questionData.ct_question_medical_exposures_type_ids = methods.getAutocompleteTagsValueConfigs(questionData.ct_question_medical_exposures_type_ids, exposureTypesRes);
            }
            //merge backend and input config data with default values
            let newQuestionsData = Object.assign({
                testing_stream: null,
                spaces_visited_details: null,
                ct_question_department: null,
                external_organization: null,
                last_day_on_campus: null,
                cr_dep_unionized_position: null,
                emergency_contact_email: null,
                emergency_contact_phone: null,
                // contact_tracer_mit_id: null,
                // ct_hospitalized: null,
                ct_question_medical_person_type_id: null,
                ct_question_medical_exposures_type_ids: [],
                fac_building_keys: [],
                // medical_location_ids: []
            }, questionData);
            //check for emergency contact info to display in form or not.
            if (newQuestionsData.emergency_contact_email || newQuestionsData.emergency_contact_phone) {
                setAddingContactPerson(true);
            }
            else {
                setAddingContactPerson(false);
            }
            //check accinated values to show/hide date_of_last_shot input.
            if (!!newQuestionsData.vaccinated && (newQuestionsData.vaccinated !== 'No')) {
                setShowLastShotDate(true);
            }
            else {
                setShowLastShotDate(false);
            }
            // console.log('newQuestionsData, answerData', newQuestionsData, answerData);
            return newQuestionsData;
        },
        //updateQuestions: save to backend using case guid and answers with values.
        // if null or empty list it will override any values in the DB as such
        updateQuestions() {
            setIsBusyUpdating(true);
            ContactTracingApi_1.default.updateContactQuestions(answers.ct_case_guid, answers, contact === null || contact === void 0 ? void 0 : contact.contact_guid).then((response) => {
                if (response.error) {
                    setIsBusyUpdating(false);
                    react_toastify_1.toast.error('Could not update answers.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                else if (response.unauth) {
                    setIsBusyUpdating(false);
                    setUnAuth(true);
                }
                else {
                    if (response) {
                        setIsBusyUpdating(false);
                        methods.fetchAllData();
                    }
                }
            });
        },
        //updateAnswers: map input values back to saveable data on input value changes
        updateAnswers(dataKey, values) {
            // console.log('updateAnswers:: UPDATING VALUES', dataKey, values);
            if (values) {
                let val;
                switch (dataKey) {
                    case 'vaccinated':
                        val = values.text;
                        break;
                    // case 'ct_hospitalized':
                    case 'cr_dep_unionized_position':
                        val = values === 'Neutral';
                        break;
                    case 'testing_stream':
                    case 'ct_question_medical_person_type_id':
                        val = values.id;
                        break;
                    // case 'medical_location_ids': 
                    case 'ct_question_medical_exposures_type_ids':
                    case 'fac_building_keys':
                        val = values.map((o) => o.id);
                        break;
                    default:
                        val = values;
                        break;
                }
                // console.log('updateAnswers:: updated answer', dataKey, val)
                setAnswers(Object.assign(Object.assign({}, answers), { [dataKey]: val }));
            }
            else {
                //delete property if null.
                let newAnswers = Object.assign({}, answers);
                if (dataKey == 'emergency_contact') {
                    delete newAnswers.emergency_contact_phone;
                    delete newAnswers.emergency_contact_email;
                }
                else {
                    delete newAnswers[dataKey];
                }
                setAnswers(newAnswers);
            }
        }
    };
    //MOUNTED FETCH DATA
    (0, react_1.useEffect)(() => {
        methods.fetchAllData();
        // eslint-disable-next-line
    }, []);
    /*  useEffect(()=>{
         // eslint-disable-next-line
     }, [answers]); */
    (0, react_1.useEffect)(() => {
        // console.log('Vaccinated Date', answers.vaccinated);
        if (!answers.vaccinated || answers.vaccinated === 'No') {
            methods.updateAnswers('date_of_last_shot', null);
            setShowLastShotDate(false);
        }
        else {
            setShowLastShotDate(true);
        }
        // eslint-disable-next-line
    }, [answers.vaccinated]);
    //INPUT CONFIGS mostly dropdown and auto complete options.
    const configs = {
        dropdownOptions: {
            fac_buildings: buildings,
            // medical_locations: locations,
            person_types: personTypes,
            exposures_types: exposureTypes,
            testing_streams: testStreamTypes,
            vaccinated_types: [{ text: 'Fully', id: 'Fully', icon: '' }, { text: 'Partially', id: 'Partially', icon: '' }, { text: 'No', id: 'No', icon: '' }]
        }
    };
    //Check auth and load errors or show form with DB or default values if no DB values.
    if (isError)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Oops.. something went wrong", type: hui_1.ErrorType.Generic });
    else if (unAuth)
        return (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Component, message: "Not Authorized", type: hui_1.ErrorType.AccessDenied });
    else
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isLoading ? ((0, jsx_runtime_1.jsx)(hui_1.ActionList, { isLoading: true, items: [] })) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "container", id: "contact-tracing-questions" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row " }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col xs-12 md-6 align-self-start" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Form, Object.assign({ formValidationTrigger: "onBlur" }, { children: (formMethods) => {
                                //To update calendar in the 
                                let lastDay = formMethods.watch('last_day_on_campus');
                                (0, react_1.useEffect)(() => {
                                    methods.updateAnswers('last_day_on_campus', lastDay);
                                }, [lastDay]);
                                //To update calendar in the 
                                let lastShotDate = formMethods.watch('date_of_last_shot');
                                (0, react_1.useEffect)(() => {
                                    methods.updateAnswers('date_of_last_shot', lastShotDate);
                                }, [lastShotDate]);
                                //check valid and save data.
                                const saveQuestions = () => {
                                    formMethods.trigger().then((valid) => {
                                        if (!valid)
                                            return;
                                        methods.updateQuestions();
                                    });
                                };
                                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(hui_1.FormContainer /* initialValues={contactQuestions} */, Object.assign({ id: "ContactTracingQuestionsForm", methods: formMethods, formValidationTrigger: "onBlur" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group row p-0 m-0" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-sm-4 text-right col-form-label p-0 m-0" }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-8 text-right p-0 m-0" }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "date-display" }, { children: (!!contactQuestions.created_on || !!contactQuestions.updated_on) ? `Last updated on: ${(0, Formatters_1.displayDateTimeShort)(contactQuestions.updated_on || contactQuestions.created_on)}` : '' })) }))] })), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "ct_question_department", editor: "textbox", label: "Department", labelDisplay: "nextto", readonly: false, required: false, properties: {
                                                        placeholder: 'Enter Department'
                                                    }, value: contactQuestions.ct_question_department, onChange: (e) => { methods.updateAnswers('ct_question_department', e.currentTarget.value); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "external_organization", editor: "textbox", label: "Organization", labelDisplay: "nextto", readonly: false, required: false, properties: {
                                                        placeholder: 'Enter organization'
                                                    }, value: contactQuestions.external_organization, onChange: (e) => { methods.updateAnswers('external_organization', e.currentTarget.value); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "cr_dep_unionized_position", editor: "toggle", label: "Unionized position", labelDisplay: "nextto", readonly: false, properties: {
                                                        positiveLabel: 'Non-unionized',
                                                        neutralLabel: 'Unionized',
                                                        negativeLabel: 'Unknown',
                                                        ariaLabel: 'Contact tracing question, unionised or ununionized position?',
                                                        showBothOptions: true
                                                    }, choice: contactQuestions.cr_dep_unionized_position === null ? 'Negative' : !!contactQuestions.cr_dep_unionized_position ? 'Neutral' : 'Positive', onClick: (e) => { e.SWITCH_STATE.choice === 'Negative' ? methods.updateAnswers('cr_dep_unionized_position', null) : methods.updateAnswers('cr_dep_unionized_position', e.SWITCH_STATE.choice); } }), !addingContactPerson ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group row" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-4 text-right col-form-label" }, { children: "Emergency contact." })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-8" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { text: "Add an emergency contact person", block: true, icon: "plus", type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: () => setAddingContactPerson(true) }) }))] }))) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "pb-2 text-right" }, { children: [(0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "emergency_contact_email", editor: "textbox", label: "Emergency Contact Email", labelDisplay: "nextto", required: true, readonly: false, properties: {
                                                                placeholder: 'Select email'
                                                            }, pattern: {
                                                                value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                                message: "Email format",
                                                            }, value: contactQuestions.emergency_contact_email, onChange: (e) => { methods.updateAnswers('emergency_contact_email', e.currentTarget.value); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "emergency_contact_phone", editor: "textbox", label: "Emergency Contact Phone", labelDisplay: "nextto", required: true, readonly: false, properties: {
                                                                placeholder: 'Enter Phone'
                                                            }, value: (0, Formatters_1.formatPhoneNumber)(contactQuestions.emergency_contact_phone), onChange: (e) => { methods.updateAnswers('emergency_contact_phone', e.currentTarget.value); } }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group row" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-sm-4 text-right col-form-label" }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-8" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { text: "Remove this emergency contact person", block: true, icon: "minus", type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: () => {
                                                                            methods.updateAnswers('emergency_contact', null);
                                                                            setAddingContactPerson(false);
                                                                        } }) }))] }))] }))), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "last_day_on_campus", editor: "calendar", label: "Last day on campus?", labelDisplay: "nextto", readonly: false, properties: {
                                                        clearable: true
                                                    }, maxDate: methods.getMaxDate(new Date()), value: contactQuestions.last_day_on_campus, onChange: (e) => { methods.updateAnswers('last_day_on_campus', e); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "testing_stream", editor: "dropdown", readonly: false, label: "Testing Streams", labelDisplay: "nextto", properties: {
                                                        placeholder: 'Select Stream'
                                                    }, options: configs.dropdownOptions.testing_streams, value: methods.getDropdownValueConfigs(contactQuestions.testing_stream, configs.dropdownOptions.testing_streams), onChange: (e) => { methods.updateAnswers('testing_stream', e); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "ct_question_medical_person_type_id", editor: "dropdown", readonly: false, label: "Did person report symptoms in the initial contact tracing conversation?", labelDisplay: "nextto", properties: {
                                                        placeholder: 'Select option'
                                                    }, options: configs.dropdownOptions.person_types, value: methods.getDropdownValueConfigs(contactQuestions.ct_question_medical_person_type_id, configs.dropdownOptions.person_types), onChange: (e) => { methods.updateAnswers('ct_question_medical_person_type_id', e); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "ct_question_medical_exposures_type_ids", editor: "autocomplete", label: "Did person report a possible route of exposure in the initial contact tracing conversation?", labelDisplay: "nextto", readonly: false, properties: {
                                                        type: 'tags',
                                                        limit: Infinity,
                                                        showItemsOnFocus: true,
                                                        placeholder: 'Select exposure route.'
                                                    }, items: configs.dropdownOptions.exposures_types, value: contactQuestions.ct_question_medical_exposures_type_ids, onChange: (e) => { methods.updateAnswers('ct_question_medical_exposures_type_ids', e); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "spaces_visited_details", editor: "multilinetextbox", readonly: false, properties: {
                                                        maxLength: 512
                                                    }, label: "Which campus spaces have you been to in the last 48 hours? Include details on dates if provided.", labelDisplay: "nextto", placeholder: "Enter as much descriptive information as possible please. (dates,times, place information)", value: contactQuestions.spaces_visited_details, onChange: (e) => { methods.updateAnswers('spaces_visited_details', e.currentTarget.value.trim()); } }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group row p-0 m-0" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-sm-4 text-right col-form-label p-0 m-0" }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-8 text-right p-0 m-0" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Text, { italic: true, bold: false, color: answers.spaces_visited_details ? answers.spaces_visited_details.trim().length <= 512 ? 'grey' : 'red' : 'grey', type: hui_1.TextType.Body, content: `${answers.spaces_visited_details ? answers.spaces_visited_details.trim().length : '0'}/512` }) }))] })), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "vaccinated", editor: "dropdown", readonly: false, label: "Have you been vaccinated?", labelDisplay: "nextto", options: configs.dropdownOptions.vaccinated_types, 
                                                    // value={methods.getVaccinatedText(contactQuestions.vaccinated)}
                                                    value: methods.getDropdownValueConfigs(answers.vaccinated || contactQuestions.vaccinated, configs.dropdownOptions.vaccinated_types), onChange: (e) => { methods.updateAnswers('vaccinated', e); } }), showLastShotDate &&
                                                    (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "date_of_last_shot", editor: "calendar", label: "Date of last shot?", labelDisplay: "nextto", readonly: false, required: false, properties: {
                                                            clearable: true
                                                        }, maxDate: methods.getMaxDate(new Date()), value: contactQuestions.date_of_last_shot, onChange: (e) => { methods.updateAnswers('date_of_last_shot', e); } }), (0, jsx_runtime_1.jsx)(hui_1.FormField, { id: "additional_comments", editor: "multilinetextbox", readonly: false, properties: {
                                                        maxLength: 512
                                                    }, label: "Additional comments", labelDisplay: "nextto", placeholder: "At a glance summary of case. Please include # of close contacts, special circumstances, any relevant case information", value: contactQuestions.additional_comments, onChange: (e) => { methods.updateAnswers('additional_comments', e.currentTarget.value.trim()); } }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group row p-0 m-0" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-sm-4 text-right col-form-label p-0 m-0" }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-8 text-right p-0 m-0" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Text, { italic: true, bold: false, color: answers.additional_comments ? answers.additional_comments.trim().length <= 512 ? 'grey' : 'red' : 'grey', type: hui_1.TextType.Body, content: `${answers.additional_comments ? answers.additional_comments.trim().length : '0'}/512` }) }))] }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "row pt-4 pb-4" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-12" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "row justify-content-end" }, { children: [!contact && (0, jsx_runtime_1.jsx)(addContactButton_1.default, { roles: roles, caseData: caseData, selectedContact: contact, doneCallback: addedContactCallback }), (0, jsx_runtime_1.jsx)(hui_1.Button, { text: "Update", icon: 'check', state: isBusyUpdating ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, isBusy: isBusyUpdating, onClick: () => saveQuestions() })] })) })) }))] }));
                            } })) })) })) }))) }));
};
const QuestionsView = (0, mobx_react_1.inject)("roles")((0, mobx_react_1.observer)(QuestionsViewComponent));
exports.default = QuestionsView;
